"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _InputType = _interopRequireDefault(require("./InputType"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/index.js";
var timeout;
var types = ['String', 'Date'];
function Search(_ref) {
  var _this = this;
  var className = _ref.className,
    fields = _ref.fields,
    onSubmit = _ref.onSubmit;
  var _React$useState = _react["default"].useState(),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    key = _React$useState2[0],
    setKey = _React$useState2[1];
  var _React$useState3 = _react["default"].useState({}),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    where = _React$useState4[0],
    setWhere = _React$useState4[1];
  function submit(e) {
    e.preventDefault();
    onSubmit(where);
  }
  _react["default"].useEffect(function () {
    var keys = Object.keys(fields);
    setKey(keys[0]);
  }, [fields]);
  function onChange(where) {
    setWhere(where);
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      onSubmit(where);
    }, 300);
  }
  return /*#__PURE__*/_react["default"].createElement("form", {
    className: className,
    onSubmit: submit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-end",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "input-group-text rounded-0 rounded-start",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 18
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-search",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 21
    }
  })), /*#__PURE__*/_react["default"].createElement("select", {
    value: key,
    className: "form-select shadow-none fs-xs w-auto rounded-0",
    onChange: function onChange(e) {
      return setKey(e.target.value);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 17
    }
  }, Object.keys(fields).map(function (key) {
    var options = fields[key];
    if (!types.includes(options.type)) return null;
    if (options.hasOwnProperty('read') && !options.read) return null;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: key,
      value: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 37
      }
    }, key);
  })), fields[key] && /*#__PURE__*/_react["default"].createElement(_InputType["default"], {
    type: fields[key].type,
    field: key,
    onChange: onChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 25
    }
  })));
}
var _default = Search;
exports["default"] = _default;